import React from "react";
import Page from "../../common/page/Page.js";
import useTranslationAdmin from "../useTranslationAdmin.js";
import ApplicationCountByJobBlock from "./ApplicationCountByJobBlock.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import WithRedirectionUserIsAuthorized from "../../authentication-ui/WithRedirectionUserIsAuthorized.js";


export default function ApplicationCountByJobPage(/*props*/) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "ApplicationCountByJobPage");

  return (
    <WithRedirectionUserIsAuthorized
      yes={() => (
        <Page className="ApplicationCountByJobPage">
          <Page.Title
            text={t("admin:admin_application_count_by_job_page_title")}
            loading={tLoading}
          />
          <Page.Content>
            <ApplicationCountByJobBlock />
          </Page.Content>
        </Page>
      )}
    />
  );
}
